import img_academy_featured from '@/assets/images/autumn-harvest-collection.png';
import designIcon from '@/assets/icons/academy/design.svg';
import flooringIcon from '@/assets/icons/academy/flooring-101.svg';
import installationIcon from '@/assets/icons/academy/installation.svg';
import careIcon from '@/assets/icons/academy/care.svg';
import residentialIcon from '@/assets/icons/academy/residential.svg';
import warrantyIcon from '@/assets/icons/academy/warranty.svg';
import { PDF_WARRANTY } from '@/constants/pdf';

/**
 * Centralized Academy mega-menu configuration.
 * Rendered entirely from this data — no menu items are hardcoded in JSX.
 * Each item: { label, href, pdf, children, description, featured }
 * Items with `children` render those links nested beneath them (desktop and mobile).
 * Items with `pdf: { url, title }` open the PDF in a viewer modal (new tab on mobile).
 * Items without `href` or `pdf` render as inert, non-navigable labels.
 * Groups with `hideOnMobile: true` are left out of the mobile drawer (below 1024px).
 */
export const academyMenu = [
  {
    title: 'Learn',
    items: [
      { label: 'Design', icon: designIcon },
      {
        label: 'Flooring 101',
        icon: flooringIcon,
        href: '/academy/hardwood-basics',
      },
      { label: 'Installation', href: '/resources', icon: installationIcon },
      { label: 'Care', href: '/academy/floor-care', icon: careIcon },
      {
        label: 'Warranty',
        icon: warrantyIcon,
        pdf: { url: PDF_WARRANTY, title: 'Warranty' },
      },
    ],
  },
  {
    title: 'Explore',
    items: [{ label: 'Residential Projects', href: '/gallery', icon: residentialIcon }],
  },
  {
    title: 'From the Journal',
    hideOnMobile: true,
    items: [
      {
        label: 'What Is Engineered Hardwood Flooring',
        href: '/academy/hardwood-basics/what-is-hardwood-flooring',
        description:
          'Explore how engineered hardwood is constructed, why it remains stable, and how to choose the right floor.',
        featured: true,
        image: img_academy_featured,
      },
    ],
  },
];
